/* 全部模組共用的命名空間。第 2 步先維持原本「大家掛在 SG 上」的做法，讓搬檔不改變任何行為；
 * 之後逐步改成明確的 import／export。和 globalThis.SG 是同一個物件，測試與伺服器照常可以用 SG.xxx。 */
const g = globalThis as any;
if (typeof g.window === 'undefined') g.window = g; // 伺服器與測試沒有 window
export const SG: any = g.SG || (g.SG = {});
